const NotFound = () => {
    return <div>
        <h1 className="text-light">Page not found</h1>
    </div>
}

export default NotFound;